import { Routes, Route, Navigate } from 'react-router-dom';

import HomePlaceholder from './pages/HomePlaceholder';
import LoginPage from './pages/auth/LoginPage';
import PostLoginPage from './pages/auth/PostLoginPage';
import OnboardingComingSoonPage from './pages/auth/OnboardingComingSoonPage';
import FirstRunPage from './pages/onboarding/FirstRunPage';
import SessionDebugPage from './pages/dev/SessionDebugPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import OnboardingPage from './pages/onboarding/OnboardingPage';
import OnboardingPaymentPage from './pages/onboarding/OnboardingPaymentPage';
import OnboardingProvisioningPage from './pages/onboarding/OnboardingProvisioningPage';
import AccountActivationPage from './pages/onboarding/AccountActivationPage';
import AcceptTeamInvitePage from './pages/onboarding/AcceptTeamInvitePage';
import PlatformCustomersPage from './pages/platform/CustomersPage';
import PlatformOnboardingSessionsPage from './pages/platform/OnboardingSessionsPage';
import PlatformLoginPage from './pages/platform/LoginPage';
import PlatformForgotPasswordPage from './pages/platform/ForgotPasswordPage';
import PlatformResetPasswordPage from './pages/platform/ResetPasswordPage';
import PlatformDashboardPage from './pages/platform/DashboardPage';
import PlatformTenantsPage from './pages/platform/TenantsPage';
import PlatformTenantDetailPage from './pages/platform/TenantDetailPage';
import PlatformAuditLogPage from './pages/platform/AuditLogPage';
import PlatformActivityLogsPage from './pages/platform/ActivityLogsPage';
import PlatformSettingsPage from './pages/platform/SettingsPage';
import PlatformSettingsAccountPage from './pages/platform/SettingsAccountPage';
import PlatformSettingsAppearancePage from './pages/platform/SettingsAppearancePage';
import PlatformTeamPage from './pages/platform/TeamPage';
import PlatformUsersPage from './pages/platform/UsersPage';
import PlatformUserDetailPage from './pages/platform/UserDetailPage';
import PlatformSecurityPage from './pages/platform/SecurityPage';
import PlatformBillingPage from './pages/platform/BillingPage';
import PlatformPlansPricingPage from './pages/platform/PlansPricingPage';
import PlatformSupportPage from './pages/platform/SupportPage';
import PlatformSupportTicketDetailPage from './pages/platform/SupportTicketDetailPage';
import PlatformNotificationHealthPage from './pages/platform/NotificationHealthPage';
import { PlatformShell } from './components/platform/PlatformShell';
import { PlatformSettingsShell } from './components/platform/PlatformSettingsShell';
import { PlatformProtectedRoute } from './components/platform/PlatformProtectedRoute';
import SolicitorLoginPage from './pages/solicitor/SolicitorLoginPage';
import SolicitorVerifyPage from './pages/solicitor/SolicitorVerifyPage';
import SolicitorDashboardPage from './pages/solicitor/SolicitorDashboardPage';
import MyMattersPage from './pages/solicitor/MyMattersPage';
import SolicitorMatterDetailPage from './pages/solicitor/MatterDetailPage';
import SolicitorDocumentsPage from './pages/solicitor/DocumentsPage';
import SolicitorCalendarPage from './pages/solicitor/CalendarPage';
import SolicitorFeesPage from './pages/solicitor/FeesPage';
import SolicitorMessagesPage from './pages/solicitor/MessagesPage';
import { AppShell } from './components/layout/AppShell';
import { ProtectedRoute } from './components/shared/ProtectedRoute';

// Admin pages
import AdminDashboardPage from './pages/admin/DashboardPage';
import MattersListPage from './pages/admin/MattersListPage';
import MatterDetailPage from './pages/admin/MatterDetailPage';
import HearingsPage from './pages/admin/HearingsPage';
import HearingDetailPage from './pages/admin/HearingDetailPage';
import JudgmentsPage from './pages/admin/JudgmentsPage';
import JudgmentDetailPage from './pages/admin/JudgmentDetailPage';
import CalendarPage from './pages/admin/CalendarPage';
import ContactsPage from './pages/admin/ContactsPage';
import BarristersPage from './pages/admin/BarristersPage';
import BarristerDetailPage from './pages/admin/BarristerDetailPage';
import ClerksPage from './pages/admin/ClerksPage';
import CourtsPage from './pages/admin/CourtsPage';
import PracticeAreasPage from './pages/admin/PracticeAreasPage';
import DocumentsPage from './pages/admin/DocumentsPage';
import TasksPage from './pages/admin/TasksPage';
import CommunicationsPage from './pages/admin/CommunicationsPage';
import FeesPage from './pages/admin/FeesPage';
import ActivitiesPage from './pages/admin/ActivitiesPage';
import ActivityLogPage from './pages/admin/ActivityLogPage';
import BankAccountsPage from './pages/admin/BankAccountsPage';
import ReportsPage from './pages/admin/ReportsPage';
import PublicSitePage from './pages/admin/PublicSitePage';
import IntegrationsPage from './pages/admin/IntegrationsPage';
// Phase 3 — the one registry-driven Settings shell, mounted under every role's basePath.
import { SettingsShell } from './features/settings/SettingsShell';
import { SettingsSectionPage } from './features/settings/SettingsSectionPage';
import MembersPage from './pages/admin/settings/MembersPage';
import RolesPage from './pages/admin/settings/RolesPage';
import ChambersMembersPage from './pages/admin/MembersPage';
import PoliciesPage from './pages/admin/PoliciesPage';
import ConstitutionPage from './pages/admin/ConstitutionPage';
import CommitteesPage from './pages/admin/CommitteesPage';
import EthicalWallsPage from './pages/admin/EthicalWallsPage';
import FinancialPolicyPage from './pages/admin/FinancialPolicyPage';
import DiaryPolicyPage from './pages/admin/DiaryPolicyPage';
import MyPoliciesPage from './pages/shared/MyPoliciesPage';
import MySupportPage from './pages/support/MySupportPage';
import MySupportTicketPage from './pages/support/MySupportTicketPage';
import BillSettingsPage from './pages/admin/settings/BillSettingsPage';
import ChambersSettingsPage from './pages/admin/settings/ChambersSettingsPage';
import CalendarSyncHealthPage from './pages/admin/settings/CalendarSyncHealthPage';
import EmailSyncHealthPage from './pages/admin/settings/EmailSyncHealthPage';
import NewMatterPage from './pages/admin/NewMatterPage';
import NewHearingPage from './pages/admin/NewHearingPage';
import NewContactPage from './pages/admin/NewContactPage';
import ContactDetailPage from './pages/admin/ContactDetailPage';
import NewJudgmentPage from './pages/admin/NewJudgmentPage';
import MatterPipelinePage from './pages/admin/MatterPipelinePage';
import IntakeInboxPage from './pages/admin/IntakeInboxPage';
import ConflictReviewsPage from './pages/admin/ConflictReviewsPage';
import IntakePage from './pages/public/IntakePage';

// Barrister pages
import BarristerDashboardPage from './pages/barrister/DashboardPage';
import BarristerMattersPage from './pages/barrister/MyMattersPage';
import MyHearingsPage from './pages/barrister/MyHearingsPage';
import CourtModePage from './pages/barrister/CourtModePage';
import MyDiaryPage from './pages/barrister/MyDiaryPage';
import MyJudgmentsPage from './pages/barrister/MyJudgmentsPage';
import MyClientsPage from './pages/barrister/MyClientsPage';
import MyDocumentsPage from './pages/barrister/MyDocumentsPage';
import MyTasksPage from './pages/barrister/MyTasksPage';
import PublicProfilePage from './pages/barrister/PublicProfilePage';
import AvailabilityPage from './pages/barrister/AvailabilityPage';
import MyFeesPage from './pages/barrister/MyFeesPage';
import MyReportsPage from './pages/barrister/MyReportsPage';
import MyCommunicationsPage from './pages/barrister/MyCommunicationsPage';
import InboxPage from './pages/barrister/InboxPage';
import InboxSearchPage from './pages/barrister/InboxSearchPage';
import InboxLabelsPage from './pages/barrister/InboxLabelsPage';
import InboxSettingsHubPage from './pages/barrister/InboxSettingsHubPage';
import InboxFiltersPage from './pages/barrister/InboxFiltersPage';
import InboxFilterBuilderPage from './pages/barrister/InboxFilterBuilderPage';
import InboxTemplatesPage from './pages/barrister/InboxTemplatesPage';
import InboxTemplateEditorPage from './pages/barrister/InboxTemplateEditorPage';
import InboxSignaturesPage from './pages/barrister/InboxSignaturesPage';
import InboxSignatureEditorPage from './pages/barrister/InboxSignatureEditorPage';
import InboxGeneralSettingsPage from './pages/barrister/InboxGeneralSettingsPage';
import ClerkCommunicationsPage from './pages/clerk/CommunicationsPage';
import MyTeamPage from './pages/barrister/MyTeamPage';
import FeeSettingsPage from './pages/barrister/FeeSettingsPage';
import PrepChecklistSettingsPage from './pages/barrister/PrepChecklistSettingsPage';
import PublicProfileSettingsPage from './pages/barrister/PublicProfileSettingsPage';
import PracticeAreasSettingsPage from './pages/barrister/PracticeAreasSettingsPage';
import PrivacySettingsPage from './pages/barrister/PrivacySettingsPage';
import CalendarSharingPage from './pages/barrister/CalendarSharingPage';
import EmailIdentityPage from './pages/barrister/EmailIdentityPage';
import NotificationsPage from './pages/shared/NotificationsPage';
import { ClerkPermissionGuard } from './components/shared/ClerkPermissionGuard';

// Clerk pages
import ClerkDashboardPage from './pages/clerk/DashboardPage';
import OperationsCenterPage from './pages/clerk/OperationsCenterPage';
import ControlTowerPage from './pages/clerk/ControlTowerPage';
import CoverageBoardPage from './pages/clerk/CoverageBoardPage';
import CourtBoardPage from './pages/clerk/CourtBoardPage';
import ChambersOperationsPage from './pages/clerk/ChambersOperationsPage';
import MasterDiaryPage from './pages/clerk/MasterDiaryPage';
import BookingsPage from './pages/clerk/BookingsPage';
import SchedulePage from './pages/clerk/SchedulePage';
import AvailabilityApprovalsPage from './pages/clerk/AvailabilityApprovalsPage';
import ClerkCoverPage from './pages/clerk/ClerkCoverPage';
import RecoveryQueuePage from './pages/clerk/RecoveryQueuePage';
import ClerkMyBarristersPage from './pages/clerk/MyBarristersPage';

const ADMIN_ONLY = ['admin', 'staff'] as const;
const CLERKS = ['senior_clerk', 'junior_clerk'] as const;
const BARRISTERS = ['silk', 'junior', 'pupil', 'door_tenant'] as const;
const SOLICITORS = ['solicitor'] as const;

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<HomePlaceholder />} />
      <Route path="/login" element={<LoginPage />} />
      {/* Session Bootstrap — OAuth callback lands here; renders the resolver's nextState */}
      <Route path="/post-login" element={<PostLoginPage />} />
      {/* First-run experience — post-activation Welcome → First Value → First Success */}
      <Route path="/welcome" element={<FirstRunPage />} />
      {/* Start a practice → the real signup flow. Redirect keeps any bookmarked /create-workspace alive. */}
      <Route path="/create-workspace" element={<Navigate to="/onboarding" replace />} />
      <Route path="/join-workspace" element={<OnboardingComingSoonPage />} />
      {/* DEV-only resolver inspector — observable session lifecycle during validation. Remove before GA. */}
      {import.meta.env.DEV && <Route path="/dev/session" element={<SessionDebugPage />} />}
      {/* Account Security now lives in Settings itself. This path is kept because the
          connect-provider OAuth callback redirects to it with ?linked / ?error — the query string
          survives the redirect and is read by the Login methods panel inside the section. */}
      <Route path="/settings/security" element={<Navigate to="/settings/section/security" replace />} />
      {/* Role-agnostic Settings — the home for members with no role-scoped area of their own
          (staff). The same shell the practitioner and clerk paths mount. */}
      <Route path="/settings" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route element={<SettingsShell />}>
          <Route index element={null} />
          <Route path="section/:sectionId" element={<SettingsSectionPage />} />
        </Route>
      </Route>
      {/* Cross-role member page — must render INSIDE the app shell (sidebar + topbar),
          otherwise it opens as a bare full-screen page with no left navbar. */}
      <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/me/policies" element={<MyPoliciesPage />} />
        {/* Support is cross-role by design: a barrister, clerk, chambers admin, staff member or
            portal solicitor all reach the same page. Visibility is by OWNERSHIP (requester-only),
            not by role, so there is nothing to branch on a basePath for. */}
        <Route path="/me/support" element={<MySupportPage />} />
        <Route path="/me/support/:id" element={<MySupportTicketPage />} />
      </Route>
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/intake/:chambersSlug" element={<IntakePage />} />

      {/* Solicitor portal — public entry */}
      <Route path="/solicitor/login" element={<SolicitorLoginPage />} />
      <Route path="/solicitor/verify" element={<SolicitorVerifyPage />} />

      {/* ─── SOLICITOR PORTAL ──────────────────────── */}
      <Route
        element={
          <ProtectedRoute allowedMemberTypes={[...SOLICITORS]} loginRoute="/solicitor/login">
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/solicitor" element={<SolicitorDashboardPage />} />
        <Route path="/solicitor/matters" element={<MyMattersPage />} />
        <Route path="/solicitor/matters/:id" element={<SolicitorMatterDetailPage />} />
        <Route path="/solicitor/documents" element={<SolicitorDocumentsPage />} />
        <Route path="/solicitor/calendar" element={<SolicitorCalendarPage />} />
        <Route path="/solicitor/fees" element={<SolicitorFeesPage />} />
        <Route path="/solicitor/messages" element={<SolicitorMessagesPage />} />
      </Route>

      {/* ─── ADMIN ─────────────────────────────── */}
      <Route
        element={
          <ProtectedRoute allowedMemberTypes={[...ADMIN_ONLY]}>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/admin/operations-board" element={<ChambersOperationsPage />} />
        <Route path="/admin/bookings" element={<BookingsPage />} />
        <Route path="/admin/cover" element={<ClerkCoverPage />} />
        <Route path="/admin/availability-approvals" element={<AvailabilityApprovalsPage />} />
        <Route path="/admin/matters/new" element={<NewMatterPage />} />
        <Route path="/admin/matters/pipeline" element={<MatterPipelinePage />} />
        <Route path="/admin/matters" element={<MattersListPage />} />
        <Route path="/admin/matters/:id" element={<MatterDetailPage />} />
        <Route path="/admin/intake" element={<IntakeInboxPage />} />
        <Route path="/admin/conflict-reviews" element={<ConflictReviewsPage />} />
        <Route path="/admin/hearings/new" element={<NewHearingPage />} />
        <Route path="/admin/hearings" element={<HearingsPage />} />
        <Route path="/admin/hearings/:id" element={<HearingDetailPage />} />
        <Route path="/admin/judgments/new" element={<NewJudgmentPage />} />
        <Route path="/admin/judgments" element={<JudgmentsPage />} />
        <Route path="/admin/judgments/:id" element={<JudgmentDetailPage />} />
        <Route path="/admin/calendar" element={<CalendarPage />} />
        <Route path="/admin/contacts/new" element={<NewContactPage />} />
        <Route path="/admin/contacts/:id" element={<ContactDetailPage />} />
        <Route path="/admin/contacts" element={<ContactsPage />} />
        <Route path="/admin/barristers" element={<BarristersPage />} />
        <Route path="/admin/members" element={<ChambersMembersPage />} />
        <Route path="/admin/policies" element={<PoliciesPage />} />
        <Route path="/admin/constitution" element={<ConstitutionPage />} />
        <Route path="/admin/committees" element={<CommitteesPage />} />
        <Route path="/admin/ethical-walls" element={<EthicalWallsPage />} />
        <Route path="/admin/settings/financial-policy" element={<FinancialPolicyPage />} />
        <Route path="/admin/settings/diary-policy" element={<DiaryPolicyPage />} />
        <Route path="/admin/barristers/:id" element={<BarristerDetailPage />} />
        <Route path="/admin/clerks" element={<ClerksPage />} />
        <Route path="/admin/courts" element={<CourtsPage />} />
        <Route path="/admin/practice-areas" element={<PracticeAreasPage />} />
        <Route path="/admin/documents" element={<DocumentsPage />} />
        <Route path="/admin/tasks" element={<TasksPage />} />
        <Route path="/admin/communications" element={<CommunicationsPage />} />
        <Route path="/admin/fees" element={<FeesPage />} />
        <Route path="/admin/activities" element={<ActivitiesPage />} />
        <Route path="/admin/activity-log" element={<ActivityLogPage />} />
        <Route path="/admin/bank-accounts" element={<BankAccountsPage />} />
        <Route path="/admin/reports" element={<ReportsPage />} />
        <Route path="/admin/public-site" element={<PublicSitePage />} />
        <Route path="/admin/integrations" element={<IntegrationsPage />} />
        <Route path="/admin/settings" element={<SettingsShell />}>
          <Route path="section/:sectionId" element={<SettingsSectionPage />} />
        </Route>
        <Route path="/admin/settings/users" element={<MembersPage />} />
        <Route path="/admin/settings/billing" element={<BillSettingsPage />} />
        <Route path="/admin/settings/roles" element={<RolesPage />} />
        <Route path="/admin/settings/profile" element={<Navigate to="/admin/settings/section/account" replace />} />
        {/* User-menu "My profile" navigates to {basePath}/profile — admin had no such route. */}
        <Route path="/admin/profile" element={<Navigate to="/admin/settings/section/account" replace />} />
        <Route path="/admin/settings/appearance" element={<Navigate to="/admin/settings/section/appearance" replace />} />
        <Route path="/admin/settings/calendar-health" element={<CalendarSyncHealthPage />} />
        <Route path="/admin/settings/email-health" element={<EmailSyncHealthPage />} />
        <Route path="/admin/notifications" element={<NotificationsPage />} />
        <Route path="/admin/settings/notifications" element={<Navigate to="/admin/settings/section/notifications" replace />} />
        <Route path="/admin/settings/chambers" element={<ChambersSettingsPage />} />
      </Route>

      {/* ─── BARRISTER ─────────────────────────── */}
      <Route
        element={
          <ProtectedRoute allowedMemberTypes={[...BARRISTERS]}>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/barrister" element={<BarristerDashboardPage />} />
        <Route path="/barrister/intake" element={<IntakeInboxPage />} />
        <Route path="/barrister/conflict-reviews" element={<ConflictReviewsPage />} />
        <Route path="/barrister/matters/new" element={<NewMatterPage />} />
        <Route path="/barrister/matters/pipeline" element={<MatterPipelinePage />} />
        <Route path="/barrister/matters" element={<BarristerMattersPage />} />
        <Route path="/barrister/archived" element={<BarristerMattersPage defaultTab="archived" archivedOnly />} />
        <Route path="/barrister/matters/:id" element={<MatterDetailPage />} />
        <Route path="/barrister/court-day" element={<CourtModePage />} />
        <Route path="/barrister/hearings/new" element={<NewHearingPage />} />
        <Route path="/barrister/hearings" element={<MyHearingsPage />} />
        <Route path="/barrister/hearings/:id" element={<HearingDetailPage />} />
        <Route path="/barrister/diary" element={<MyDiaryPage />} />
        <Route path="/barrister/judgments/new" element={<NewJudgmentPage />} />
        <Route path="/barrister/judgments" element={<MyJudgmentsPage />} />
        <Route path="/barrister/judgments/:id" element={<JudgmentDetailPage />} />
        <Route path="/barrister/clients/new" element={<NewContactPage />} />
        <Route path="/barrister/clients/:id" element={<ContactDetailPage />} />
        <Route path="/barrister/clients" element={<MyClientsPage />} />
        <Route path="/barrister/documents" element={<MyDocumentsPage />} />
        <Route path="/barrister/tasks" element={<MyTasksPage />} />
        <Route path="/barrister/communications" element={<MyCommunicationsPage />} />
        {/* /barrister/inbox + /search render full-screen (no AppShell) — see below */}
        <Route path="/barrister/inbox/settings" element={<InboxSettingsHubPage />} />
        <Route path="/barrister/inbox/settings/labels" element={<InboxLabelsPage />} />
        <Route path="/barrister/inbox/settings/filters" element={<InboxFiltersPage />} />
        <Route path="/barrister/inbox/settings/filters/new" element={<InboxFilterBuilderPage />} />
        <Route path="/barrister/inbox/settings/filters/:filterId/edit" element={<InboxFilterBuilderPage />} />
        <Route path="/barrister/inbox/settings/templates" element={<InboxTemplatesPage />} />
        <Route path="/barrister/inbox/settings/templates/new" element={<InboxTemplateEditorPage />} />
        <Route path="/barrister/inbox/settings/templates/:templateId/edit" element={<InboxTemplateEditorPage />} />
        <Route path="/barrister/inbox/settings/signatures" element={<InboxSignaturesPage />} />
        <Route path="/barrister/inbox/settings/signatures/new" element={<InboxSignatureEditorPage />} />
        <Route path="/barrister/inbox/settings/signatures/:signatureId/edit" element={<InboxSignatureEditorPage />} />
        <Route path="/barrister/inbox/settings/general" element={<InboxGeneralSettingsPage />} />
        <Route path="/barrister/fees" element={<MyFeesPage />} />
        {/* The same page the clerks use. A solo barrister has no clerk to chase unpaid fee notes,
            and the server already serves the workspace to silk and junior, scoped to their own
            matters (fee-notes.routes.ts RECOVERY_ROLES, fee-notes.service.ts). */}
        <Route path="/barrister/recovery" element={<RecoveryQueuePage />} />
        <Route path="/barrister/bank-accounts" element={<BankAccountsPage />} />
        <Route path="/barrister/activities" element={<ActivitiesPage />} />
        <Route path="/barrister/activity-log" element={<ActivityLogPage />} />
        <Route path="/barrister/reports" element={<MyReportsPage />} />
        <Route path="/barrister/profile" element={<PublicProfilePage />} />
        <Route path="/barrister/availability" element={<AvailabilityPage />} />
        <Route path="/barrister/settings" element={<SettingsShell />}>
          <Route path="section/:sectionId" element={<SettingsSectionPage />} />
        </Route>
        <Route path="/barrister/settings/profile" element={<Navigate to="/barrister/settings/section/account" replace />} />
        <Route path="/barrister/settings/login" element={<Navigate to="/barrister/settings/section/security" replace />} />
        {/* Clerk/team management is consolidated onto the single My Clerks page.
            Old Settings routes redirect there so existing links keep working. */}
        <Route path="/barrister/settings/team" element={<Navigate to="/barrister/my-clerks" replace />} />
        <Route path="/barrister/settings/delegation" element={<Navigate to="/barrister/my-clerks" replace />} />
        <Route path="/barrister/my-clerks" element={<MyTeamPage />} />
        <Route path="/barrister/notifications" element={<NotificationsPage />} />
        <Route path="/barrister/settings/notifications" element={<Navigate to="/barrister/settings/section/notifications" replace />} />
        <Route path="/barrister/settings/apps" element={<IntegrationsPage />} />
        <Route path="/barrister/settings/fees" element={<FeeSettingsPage />} />
        <Route path="/barrister/settings/prep-checklist" element={<PrepChecklistSettingsPage />} />
        <Route path="/barrister/settings/public-profile" element={<PublicProfileSettingsPage />} />
        <Route path="/barrister/settings/areas" element={<PracticeAreasSettingsPage />} />
        <Route path="/barrister/settings/appearance" element={<Navigate to="/barrister/settings/section/appearance" replace />} />
        <Route path="/barrister/settings/privacy" element={<PrivacySettingsPage />} />
        <Route path="/barrister/settings/calendar" element={<CalendarSharingPage />} />
        <Route path="/barrister/settings/billing" element={<BillSettingsPage />} />
        <Route path="/barrister/settings/email-identity" element={<EmailIdentityPage />} />
        <Route path="/barrister/settings/chambers" element={<ChambersSettingsPage />} />
      </Route>

      {/* ─── CLERK ─────────────────────────────── */}
      <Route
        element={
          <ProtectedRoute allowedMemberTypes={[...CLERKS]}>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/clerk" element={<ClerkDashboardPage />} />
        <Route path="/clerk/operations" element={<OperationsCenterPage />} />
        <Route path="/clerk/control-tower" element={<ClerkPermissionGuard permission="VIEW_CALENDAR"><ControlTowerPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/coverage" element={<ClerkPermissionGuard permission="VIEW_CALENDAR"><CoverageBoardPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/court-board" element={<ClerkPermissionGuard permission="VIEW_HEARINGS"><CourtBoardPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/operations-board" element={<ClerkPermissionGuard permission="VIEW_HEARINGS"><ChambersOperationsPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/diary" element={<ClerkPermissionGuard permission="VIEW_CALENDAR"><MasterDiaryPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/bookings" element={<ClerkPermissionGuard permission="RESPOND_TO_ALLOCATIONS"><BookingsPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/schedule" element={<ClerkPermissionGuard permission="VIEW_CALENDAR"><SchedulePage /></ClerkPermissionGuard>} />
        <Route path="/clerk/matters/new" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><NewMatterPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/matters/pipeline" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><MatterPipelinePage /></ClerkPermissionGuard>} />
        <Route path="/clerk/matters" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><MattersListPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/archive" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><MattersListPage initialStatus="archived" title="Archived Matters" lockStatus /></ClerkPermissionGuard>} />
        <Route path="/clerk/matters/:id" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><MatterDetailPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/intake" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><IntakeInboxPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/conflict-reviews" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><ConflictReviewsPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/hearings/new" element={<ClerkPermissionGuard permission="VIEW_HEARINGS"><NewHearingPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/hearings" element={<ClerkPermissionGuard permission="VIEW_HEARINGS"><HearingsPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/hearings/:id" element={<ClerkPermissionGuard permission="VIEW_HEARINGS"><HearingDetailPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/judgments" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><JudgmentsPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/judgments/new" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><NewJudgmentPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/judgments/:id" element={<ClerkPermissionGuard permission="VIEW_MATTERS"><JudgmentDetailPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/contacts/new" element={<NewContactPage />} />
        <Route path="/clerk/contacts/:id" element={<ContactDetailPage />} />
        {/* Personal account pages — clerks had no profile/settings routes, so the user-menu
            "My profile" and "Settings" links dead-ended. Reuse the shared, role-agnostic pages. */}
        <Route path="/clerk/profile" element={<Navigate to="/clerk/settings/section/account" replace />} />
        <Route path="/clerk/settings" element={<SettingsShell />}>
          <Route path="section/:sectionId" element={<SettingsSectionPage />} />
        </Route>
        <Route path="/clerk/settings/profile" element={<Navigate to="/clerk/settings/section/account" replace />} />
        <Route path="/clerk/settings/login" element={<Navigate to="/clerk/settings/section/security" replace />} />
        <Route path="/clerk/settings/appearance" element={<Navigate to="/clerk/settings/section/appearance" replace />} />
        <Route path="/clerk/settings/notifications" element={<Navigate to="/clerk/settings/section/notifications" replace />} />
        <Route path="/clerk/contacts" element={<ContactsPage />} />
        <Route path="/clerk/barristers" element={<BarristersPage />} />
        <Route path="/clerk/barristers/:id" element={<BarristerDetailPage />} />
        <Route path="/clerk/availability-approvals" element={<AvailabilityApprovalsPage />} />
        <Route path="/clerk/cover" element={<ClerkCoverPage />} />
        <Route path="/clerk/my-barristers" element={<ClerkMyBarristersPage />} />
        <Route path="/clerk/documents" element={<ClerkPermissionGuard permission="MANAGE_DOCUMENTS"><DocumentsPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/tasks" element={<ClerkPermissionGuard permission="MANAGE_TASKS"><TasksPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/communications" element={<ClerkPermissionGuard permission="VIEW_COMMUNICATIONS"><ClerkCommunicationsPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/fees" element={<ClerkPermissionGuard permission="MANAGE_FEES"><FeesPage /></ClerkPermissionGuard>} />
        <Route path="/clerk/recovery" element={<ClerkPermissionGuard permission="MANAGE_FEES"><RecoveryQueuePage /></ClerkPermissionGuard>} />
        <Route path="/clerk/bank-accounts" element={<BankAccountsPage />} />
        <Route path="/clerk/reports" element={<ReportsPage />} />
        <Route path="/clerk/activities" element={<ActivitiesPage />} />
        <Route path="/clerk/activity-log" element={<ActivityLogPage />} />
        <Route path="/clerk/notifications" element={<NotificationsPage />} />
      </Route>

      {/* ─── INBOX — full-screen communications workspace (no AppShell) ── */}
      {/* The inbox carries its own compact rail; it is the default email view. */}
      <Route
        path="/barrister/inbox"
        element={
          <ProtectedRoute allowedMemberTypes={[...BARRISTERS]}>
            <InboxPage standalone />
          </ProtectedRoute>
        }
      />
      <Route
        path="/barrister/inbox/full"
        element={
          <ProtectedRoute allowedMemberTypes={[...BARRISTERS]}>
            <InboxPage standalone />
          </ProtectedRoute>
        }
      />
      <Route
        path="/barrister/inbox/search"
        element={
          <ProtectedRoute allowedMemberTypes={[...BARRISTERS]}>
            <InboxSearchPage />
          </ProtectedRoute>
        }
      />

      {/* ─── PUBLIC ONBOARDING ───────────────────────────── */}

      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/onboarding/payment/:token" element={<OnboardingPaymentPage />} />
      <Route path="/onboarding/provisioning/:token" element={<OnboardingProvisioningPage />} />
      <Route path="/activate/:inviteToken" element={<AccountActivationPage />} />
      <Route path="/accept-team-invite/:token" element={<AcceptTeamInvitePage />} />

      {/* ─── PLATFORM CONSOLE ─────────────────────────────── */}
      <Route path="/platform/login" element={<PlatformLoginPage />} />
      {/* Recovery. Unauthenticated by necessity - the whole point is that the operator
          cannot sign in. accept-invite reuses the same page: both consume a one-time
          token and end with a password being set. */}
      <Route path="/platform/forgot-password" element={<PlatformForgotPasswordPage />} />
      <Route path="/platform/reset-password" element={<PlatformResetPasswordPage />} />
      <Route path="/platform/accept-invite" element={<PlatformResetPasswordPage />} />
      <Route
        element={
          <PlatformProtectedRoute>
            <PlatformShell />
          </PlatformProtectedRoute>
        }
      >
        <Route path="/platform" element={<PlatformDashboardPage />} />
        <Route path="/platform/tenants" element={<PlatformTenantsPage />} />
        <Route path="/platform/tenants/:id" element={<PlatformTenantDetailPage />} />
        <Route path="/platform/users" element={<PlatformUsersPage />} />
        <Route path="/platform/users/:id" element={<PlatformUserDetailPage />} />
        <Route path="/platform/billing" element={<PlatformBillingPage />} />
        <Route path="/platform/plans-pricing" element={<PlatformPlansPricingPage />} />
        <Route path="/platform/support" element={<PlatformSupportPage />} />
        <Route path="/platform/support/:id" element={<PlatformSupportTicketDetailPage />} />
        {/* Unified Activity Logs — one destination over three ledgers. */}
        <Route path="/platform/activity" element={<PlatformActivityLogsPage />} />
        {/*
          Backward compatibility. Each old path redirects to the CLOSEST EQUIVALENT view rather
          than a bare stream, so an existing bookmark keeps its meaning: Security was an
          authentication view, Audit Log was the platform ledger. `replace` keeps the dead URL
          out of the back-stack. The old page components stay mounted below during the
          deprecation window — nothing is deleted in this phase.
        */}
        <Route path="/platform/security" element={<Navigate to="/platform/activity?category=authentication" replace />} />
        <Route path="/platform/audit" element={<Navigate to="/platform/activity?source=platform" replace />} />
        <Route path="/platform/security/legacy" element={<PlatformSecurityPage />} />
        <Route path="/platform/audit/legacy" element={<PlatformAuditLogPage />} />
        <Route path="/platform/team" element={<PlatformTeamPage />} />
        {/* The operator's own account. `/platform/settings` was a single page holding profile
            AND password; it is now a shell with a section rail, and the bare path still resolves
            — it lands on My Account rather than 404ing a URL that has been live and bookmarked. */}
        <Route path="/platform/settings" element={<PlatformSettingsShell />}>
          <Route index element={<Navigate to="/platform/settings/account" replace />} />
          <Route path="account" element={<PlatformSettingsAccountPage />} />
          <Route path="security" element={<PlatformSettingsPage />} />
          <Route path="appearance" element={<PlatformSettingsAppearancePage />} />
        </Route>
        <Route path="/platform/notifications" element={<PlatformNotificationHealthPage />} />
        <Route path="/platform/customers" element={<PlatformCustomersPage />} />
        <Route path="/platform/onboarding" element={<PlatformOnboardingSessionsPage />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
